import { createActionTypeModel } from "../../../../store/global/action-model";

export const ContactGroups = createActionTypeModel('ContactGroups');
export const SelectedContactGroup = createActionTypeModel('SelectedContactGroup');
export const GroupContactsData = createActionTypeModel('GroupContactsData');
export const SelectedContactGroupLoading = createActionTypeModel('SelectedContactGroupLoading');
export const ContactGroupDetails = createActionTypeModel('ContactGroupDetails');

// export const SelectedContact = createActionTypeModel('SelectedContact');
// export const SEARCH_CONTACTS = 'SEARCH_CONTACTS';

// export const SelectedContactLoading = createActionTypeModel('SelectedContactLoading');
// export const SelectedContactGroups = createActionTypeModel('SelectedContactGroup');
// export const SelectedContactRelatedContacts = createActionTypeModel('SelectedContactRelatedContacts');
